import {
  Component,
  EventEmitter,
  Inject,
  Output,
  PLATFORM_ID,
  TemplateRef,
} from '@angular/core';
import { ModalArguments } from '../../../models/modal-arguments';
import { ModalButtonType } from '../../../enums/modal_button_type';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { KeywordsAndConstants } from '../../../core/keywords-and-constants';
import { LocalStorageService } from '../../../network/services/local-storage.service';
import { LoginService } from '../../../network/services/login.service';
import { DialogUtil } from '../../../utils/dialog-utils';
import { ShortNamePipe } from '../short-name.pipe';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ThemeService } from '../../../network/services/theme.service';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MessageType } from '../../../enums/message-type';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [
    BsDropdownModule,
    CommonModule,
    ShortNamePipe,
    ClipboardModule,
    RouterLink,
  ],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent {
  @Output() mobileMenuButtonClicked = new EventEmitter();
  userInfo: any;
  response: any;
  totalCount: any;

  logoUrl: string = '';

  notificationsCount: number = 0;
  notificationList: any = '';

  copiedValue: any;

  constructor(
    public constants: KeywordsAndConstants,
    public _localStorageService: LocalStorageService,
    private _loginService: LoginService,
    public dialog: DialogUtil,
    @Inject(PLATFORM_ID) private platformId: Object,
    public _logoService: ThemeService
  ) {}

  ngOnInit() {
    this._loginService.callbackResponseForUser.subscribe((response) => {
      this.response = response;
      if (isPlatformBrowser(this.platformId)) {
        let userDetails: any = localStorage.getItem(
          this.constants.LocalStorageUserInfo
        );
        this.userInfo = JSON.parse(userDetails);
      }
    });
    if (!this.response) {
      if (isPlatformBrowser(this.platformId)) {
        let userDetails: any = localStorage.getItem(
          this.constants.LocalStorageUserInfo
        );
        this.userInfo = JSON.parse(userDetails);
      }
    }
  }

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  public onClipboardCopy(successful: boolean, val: any): void {
    if (successful) {
      this.copiedValue = val;
      this.dialog.showToast('Copied', MessageType.SUCCESS);
    }
  }

  logout() {
    const contextAlias = this;
    this.dialog.errorShowModal(
      new ModalArguments('Are you sure you want to logout?')
        .withButtonType(ModalButtonType.DOUBLE_BUTTON)
        .withButtonPositiveText('Logout')
        .withButtonNegativeText('Cancel')
        .withCallback({
          buttonNegativeClicked() {},
          buttonPositiveClicked() {
            contextAlias._localStorageService.logout();
          },
          buttonSingleClicked() {},
        })
    );
  }
}
